import type { TableRowProps } from '@mui/material';
import { TableRow } from '@mui/material';
import type { ReactNode } from 'react';
import React from 'react';

interface ClickableTableRowProps extends Omit<TableRowProps, 'onClick' | 'onKeyDown'> {
  children: ReactNode;
  clickable?: boolean;
  onClick?: () => void;
}

export function ClickableTableRow({ children, clickable = false, onClick, sx, ...props }: ClickableTableRowProps) {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (clickable && onClick && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <TableRow
      {...props}
      hover={clickable}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? handleKeyDown : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      sx={{
        cursor: clickable ? 'pointer' : 'default',
        opacity: clickable ? 1 : 0.6,
        outline: 'none',
        '&:focus-visible': (theme) => ({
          boxShadow: clickable ? `inset 0 0 0 2px ${theme.palette.primary.main}` : 'none',
        }),
        '& > td': {
          backgroundColor: 'inherit',
        },
        // eslint-disable-next-line @typescript-eslint/no-misused-spread
        ...sx,
      }}
    >
      {children}
    </TableRow>
  );
}
